import PropertyTitle from "./PropertyTitle";
import React from "react";
import FontAwesome from "react-fontawesome";
import {FormControl} from "react-bootstrap";

class SchacHomeOrganizationInput extends React.Component {
    state = {
        editable: false,
        value: "",
    };

    constructor() {
        super();
        this.elemRef = React.createRef();
        this.toggleEditable = this.toggleEditable.bind(this);
        this.changeSchacHomeOrganization = this.changeSchacHomeOrganization.bind(this);
    }

    componentDidMount() {
        this.setState(prev => ({...prev, value: this.props.currentSchacHomeOrganization}));
    }

    toggleEditable() {
        if (this.state.editable) {
            this.props.onSave('schacHomeOrganization', this.state.value)
        }
        this.setState(state => ({...state, editable: !state.editable}));
    }

    changeSchacHomeOrganization() {
        this.setState(prev => ({...prev, value: this.elemRef.value}));
    }

    render() {
        const {editable, value} = this.state;
        return (
            <>
                <PropertyTitle small icon="users" text={<p>Instelling <span style={{marginLeft: 5}}>
                    <FontAwesome
                        style={{cursor: 'pointer'}}
                        className="edit"
                        name="pencil"
                        size="lg"
                        onClick={(e) => this.toggleEditable(e)}
                    />
                </span></p>}/>
                <div className="tablescontainer">
                    {!editable && (
                        <>
                            {(value) ? <p>{value}</p> :
                                <p>Niets ingesteld</p>}
                        </>
                    )}
                    {editable && (
                        <div style={{maxWidth: '20vw'}}>
                            <FormControl
                                type='text'
                                inputRef={elem => this.elemRef = elem}
                                autoFocus={true}
                                defaultValue={value}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        this.toggleEditable();
                                    }
                                }}
                                onChange={() => this.changeSchacHomeOrganization()}
                            />
                        </div>
                    )}
                </div>
            </>
        )
    }
}

export default SchacHomeOrganizationInput;
